<template>
  <div v-if="articleDocument" class="article">
    <div id="article">
      <article-header
        :article="articleDocument"
        :class="{
          'visually-hidden': articleDocument.with_image_header === false,
        }"
      />

      <article>
        <blocks :blocks="articleDocument.blocks" />
      </article>

      <comments-disqus v-if="disqusId" class="mt-md-8" :article-id="disqusId" />
    </div>

    <div v-if="hasOverrideColors" v-html="getOverrideColorsStyle()"></div>
  </div>
</template>

<script>
// import * as prismic from '@prismicio/client'
import ScrollTrackingMixin from '@/mixins/ScrollTrackingMixin'
import ArticleHeader from '@/components/header/ArticleHeader'

import Blocks from '@/components/blocks/Blocks'
import CommentsDisqus from '@/components/comments/Disqus'

import services from '@/services'

// import PrismicProduct from '@/entities/prismic/Product'
// import ShopifyProduct from '@/entities/shopify/Product'

import { ORIGIN } from '@/const'

export default {
  name: 'BlogArticle',
  components: {
    ArticleHeader,
    Blocks,
    CommentsDisqus,
  },
  mixins: [ScrollTrackingMixin],
  async asyncData({ params, i18n, $logError, payload, error }) {
    const data = {}

    if (payload && payload.articleDocument) {
      data.articleDocument = payload.articleDocument
    } else {
      try {
        if (params.type === 'guides-dentretien') {
          data.articleDocument = await services.sanityService
            .getCareGuide({
              context: params.context,
              uid: params.uid,
              lang: i18n.locale.slice(0, 2),
            })
            .then((res) => {
              if (res.length > 0) {
                return res[0]
              }

              throw new Error('care-guide-not-found')
            })
        } else {
          data.articleDocument = await services.sanityService
            .getArticle({
              context: params.context,
              uid: params.uid,
              lang: i18n.locale.slice(0, 2),
            })
            .then((res) => {
              if (res.length > 0) {
                return res[0]
              }

              throw new Error('article-not-found')
            })
        }
      } catch (err) {
        $logError.captureException(err)
        return error({ statusCode: 404, message: 'Page not found' })
      }

      // try {
      //   // Query to get post content
      //   data.prismicDocument = await $prismic.client.getByUID(
      //     'article',
      //     params.uid,
      //     {
      //       lang: i18n.locale,
      //     }
      //   )
      // } catch (e) {
      //   $logError.captureException(e)
      //   error({ statusCode: 404, message: 'Page not found' })
      // }
    }

    // if (!data.prismicDocument) {
    //   throw new Error('article-not-found')
    // }

    // if (
    //   data.prismicDocument.data.linked_product &&
    //   data.prismicDocument.data.linked_product.id
    // ) {
    //   data.linkedProductData = await $prismic.client
    //     .getByID(data.prismicDocument.data.linked_product.id, {
    //       lang: i18n.locale,
    //       graphQuery: `{
    //           product {
    //             product_name
    //             shopify_id
    //             status
    //             colors {
    //               image_principale
    //               color_name
    //               color_thumbnail
    //               third_variant_name
    //             }
    //             image
    //             button_label
    //             eshop_image
    //           }
    //         }`,
    //     })
    //     .catch((err) => {
    //       $logError.captureException(err)
    //     })

    //   if (data.linkedProductData.data.shopify_id) {
    //     const result = await services.productService.getShopifyProduct(
    //       data.linkedProductData.data.shopify_id,
    //       i18n.locale
    //     )

    //     if (result.data && result.data.data.node) {
    //       data.linkedShopifyProductData = result.data.data.node
    //     }
    //   }
    // }

    // if (
    //   data.prismicDocument.data.next_article &&
    //   data.prismicDocument.data.next_article.uid
    // ) {
    //   data.nextArticle = await $prismic.client
    //     .getByUID('article', data.prismicDocument.data.next_article.uid, {
    //       lang: i18n.locale,
    //     })
    //     .catch((err) => {
    //       $logError.captureException(err)
    //     })
    // } else if (
    //   data.prismicDocument.data.body.find(
    //     (s) => s.slice_type === 'article_link'
    //   )
    // ) {
    //   const nextArticleSlice = data.prismicDocument.data.body.find(
    //     (s) => s.slice_type === 'article_link'
    //   )

    //   if (nextArticleSlice.primary.article.uid) {
    //     data.nextArticle = await $prismic.client
    //       .getByUID('article', nextArticleSlice.primary.article.uid, {
    //         lang: i18n.locale,
    //       })
    //       .catch((err) => {
    //         $logError.captureException(err)
    //       })
    //   }
    // }

    // Returns data to be used in template
    return data
  },
  data() {
    return {
      articleDocument: null,
      nextArticle: null,
      linkedProductData: null,
      linkedProduct: null,
      linkedShopifyProductData: null,
      linkedShopifyProduct: null,
      ORIGIN,
    }
  },

  head() {
    if (this.articleDocument) {
      const route = `${
        process.env.BASE_URL ? process.env.BASE_URL : 'https://www.asphalte.com'
      }${this.$nuxt.$route.path}`

      const head = services.pageService.getHead(
        {
          type: 'article',
          title: this.articleDocument.title,
          route,
          defaultTitle: this.$t('seo.defaultTitle'),
          defaultDesc: this.$t('seo.defaultDesc'),
          sanity: this.articleDocument,
        },
        this.$generateAlternateLinksMetaSanity(
          this.articleDocument._type,
          this.articleDocument.alternate_languages
        )
      )

      if (this.articleDocument.with_image_header === true) {
        head.bodyAttrs = {
          class: 'header-transparent',
        }
      }

      // if (this.prismicDocument.data.with_header === false) {
      //   if (this.prismicDocument.data.body.length > 0) {
      //     const firstSlice = this.prismicDocument.data.body[0]

      //     if (
      //       firstSlice.slice_type === 'video' &&
      //       firstSlice.variation === 'videoBunny' &&
      //       firstSlice.primary.is_full
      //     ) {
      //       head.bodyAttrs = {
      //         class: 'header-transparent',
      //       }
      //     } else if (
      //       firstSlice.slice_type === 'image_full' &&
      //       firstSlice.variation === 'default' &&
      //       firstSlice.primary.is_full
      //     ) {
      //       head.bodyAttrs = {
      //         class: 'header-transparent',
      //       }
      //     }
      //   }
      // } else if (prismic.isFilled.image(this.prismicDocument.data.header)) {
      //   head.bodyAttrs = {
      //     class: 'header-transparent',
      //   }
      // }

      return head
    }

    return {}
  },

  computed: {
    hasOverrideColors() {
      // if (this.prismicDocument) {
      //   return (
      //     prismic.isFilled.color(this.prismicDocument.data.background_color) ||
      //     prismic.isFilled.color(this.prismicDocument.data.text_color) ||
      //     prismic.isFilled.color(
      //       this.prismicDocument.data.background_button_color
      //     ) ||
      //     prismic.isFilled.color(this.prismicDocument.data.text_button_color) ||
      //     prismic.isFilled.color(
      //       this.prismicDocument.data.hover_background_button_color
      //     ) ||
      //     prismic.isFilled.color(
      //       this.prismicDocument.data.hover_text_button_color
      //     )
      //   )
      // }
      return false
    },
    disqusId() {
      if (this.articleDocument) {
        if (this.articleDocument._id.startsWith('imported-article-')) {
          return this.articleDocument._id.replace('imported-article-', '')
        }

        return this.articleDocument._id
      }

      return null
    },
  },

  mounted() {
    if (this.articleDocument) {
      this.$track.page(this.$metaInfo, this.$route, this.$nuxt.context.from)

      // if (this.linkedProductData) {
      //   this.linkedProduct = new PrismicProduct(this.linkedProductData)
      // }

      // if (this.linkedShopifyProductData) {
      //   this.linkedShopifyProduct = new ShopifyProduct(
      //     this.linkedShopifyProductData
      //   )
      // }
    }
  },

  methods: {
    // getOverrideColorsStyle() {
    //   const style = []
    //   if (prismic.isFilled.color(this.prismicDocument.data.background_color)) {
    //     style.push(
    //       `--background-color: ${this.prismicDocument.data.background_color};`
    //     )
    //   }
    //   if (prismic.isFilled.color(this.prismicDocument.data.text_color)) {
    //     style.push(
    //       `--text-body-color: ${this.prismicDocument.data.text_color}; --title-color: ${this.prismicDocument.data.text_color};`
    //     )
    //   }
    //   if (
    //     prismic.isFilled.color(
    //       this.prismicDocument.data.background_button_color
    //     )
    //   ) {
    //     style.push(
    //       `--background-button-color: ${this.prismicDocument.data.background_button_color};`
    //     )
    //   }
    //   if (prismic.isFilled.color(this.prismicDocument.data.text_button_color)) {
    //     style.push(
    //       `--text-button-color: ${this.prismicDocument.data.text_button_color};`
    //     )
    //   }
    //   if (
    //     prismic.isFilled.color(
    //       this.prismicDocument.data.hover_background_button_color
    //     )
    //   ) {
    //     style.push(
    //       `--hover-background-button-color: ${this.prismicDocument.data.hover_background_button_color};`
    //     )
    //   }
    //   if (
    //     prismic.isFilled.color(
    //       this.prismicDocument.data.hover_text_button_color
    //     )
    //   ) {
    //     style.push(
    //       `--hover-text-button-color: ${this.prismicDocument.data.hover_text_button_color};`
    //     )
    //   }
    //   return `<style>.article { ${style.join(' ')} }</style>`
    // },
  },
}
</script>

<style lang="scss">
.article {
  background-color: var(--background-color);
  color: var(--text-body-color);

  .slices {
    > .slice.slice--alert-subscribe.side-by-side {
      &:last-child {
        @include mq($until: tablet) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
